import { PermDetail, PermisosState, UserRow } from "./state";

export default {
  setErrorMessage(s: PermisosState, msg: string | null) {
    s.errorMessage = msg;
  },

  setLoadingUsers(s: PermisosState, v: boolean) {
    s.loadingUsers = v;
  },
  setLoadingPerms(s: PermisosState, v: boolean) {
    s.loadingPerms = v;
  },
  setLoadingDetail(s: PermisosState, v: boolean) {
    s.loadingDetail = v;
  },
  setSaving(s: PermisosState, v: boolean) {
    s.saving = v;
  },

  setUsers(s: PermisosState, users: UserRow[]) {
    s.users = users;
  },

  setPermsCatalog(s: PermisosState, perms: string[]) {
    s.permsCatalog = perms;
  },

  setDetail(s: PermisosState, detail: PermDetail | null) {
    s.detail = detail;
  },
};